<p-table #dt [value]="charges" dataKey="id" styleClass="p-datatable-striped" [rows]="10" [paginator]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="['banr', 'mitarbeiternr', 'datum', 'materialnr', 'material_batchnr']"
    currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Einträgen" [showCurrentPageReport]="true">

    <ng-template pTemplate="caption">
        <div class="flex justify-content-between flex-wrap">
            <div>
                <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input pInputText type="text" #filter (input)="onGlobalFilter(dt, $event)"
                        placeholder="Globale Suche..." class="w-full" />
                </p-iconField>
            </div>
            <div>
                <p-button [outlined]="true" icon="pi pi-filter-slash" label="Filter zurücksetzen" class="ml-2"
                    (click)="clear(dt); filter.value = '';" />
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="header">
        <tr>
            <!-- Add pSortableColumn and p-sortIcon to each header you want sortable -->
            <th pSortableColumn="banr">BA-Nr. <p-sortIcon field="banr" /></th>
            <th pSortableColumn="mitarbeiternr">Mitarbeiter-Nr. <p-sortIcon field="mitarbeiternr" /></th>
            <th pSortableColumn="datum">Datum <p-sortIcon field="datum" /></th>
            <th pSortableColumn="fertigungsmenge" class="text-right">Fertigungsmenge <p-sortIcon
                    field="fertigungsmenge" /></th>
            <th pSortableColumn="materialnr">Material-Nr. <p-sortIcon field="materialnr" /></th>
            <th pSortableColumn="material_batchnr">Material Batch-Nr. <p-sortIcon field="material_batchnr" /></th>
            <!-- Add more columns as needed -->
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-charge>
        <tr>
            <td>{{ charge.banr }}</td>
            <td>{{ charge.mitarbeiternr }}</td>
            <td>{{ charge.datum | date:'dd.MM.yyyy HH:mm' }}</td> <!-- Adjust date format as needed -->
            <td class="text-right">{{ charge.fertigungsmenge }}</td>
            <td>{{ charge.materialnr }}</td>
            <td>{{ charge.material_batchnr }}</td>
            <!-- Add more cells corresponding to headers -->
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="6"> <!-- Adjust colspan based on the number of columns -->
                Keine Chargen gefunden.
            </td>
        </tr>
    </ng-template>
</p-table>